import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import React, { useState } from "react";

export default function CustomInput({
  inputProps,
  label,
  value,
  onChange,
  parentClassName,
  password,
  disabled,
}) {
  const [viewPass, setViewPass] = useState(false);
  const showLabel = Boolean(label);

  const isShortWidth = value === "Sample Location" || value === "Lab Code";

  const inputStyle = {
    ...(isShortWidth ? { width: "96%" } : {}),
    ...(showLabel ? {} : { padding: "0 17px 0 20px" }),
  };

  return (
    <div className={`float-label ${parentClassName || ""}`}>
      {showLabel && (
        <label className={value ? "Active input-field" : "input-field"}>
          {label}
        </label>
      )}
      <input
        className="form-control"
        style={inputStyle}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...inputProps}
        {...(password ? { type: viewPass ? "text" : "password" } : {})}
      />
      {password && (
        <>
          {viewPass ? (
            <VisibilityOffIcon
              className="pass-eye"
              onClick={() => setViewPass((s) => !s)}
            />
          ) : (
            <VisibilityIcon
              className="pass-eye"
              onClick={() => setViewPass((s) => !s)}
            />
          )}
        </>
      )}
    </div>
  );
}
